import React, { useEffect, useState } from "react";
import "./TextAreaInput.css";
import ToolTip from "../Tooltip/Tooltip";

const TextAreaInput = (props) => {
	const [error, setError] = useState("");

	useEffect(() => {
		setError(props.error);
	}, [props.error]);

	//caso não seja passado o handler via prop
	const handleChange = () => { };

	return (
		<label
			className="input-label"
			style={{
				display: props.hidden ? "none" : "inline-flex",
			}}
		>
			{props.labelText && (
				<div
					className={`input-tooltip-container`}
					style={{
						width: "100%",
						textAlign: "left",
						color: props.disabled
							? "var(--textColorDisabled)"
							: "var(--textColor)",
					}}
				>
					{props.labelText}
					<ToolTip
						tooltipVisible={props.tooltipVisible}
						tooltipText={props.tooltipText}
					/>
				</div>
			)}
			<textarea
				name={props.name}
				value={props.value || ""}
				className={`${error ? "input-error" : ""} ${error ? "border-red-500!" : ""} disabled:opacity-50! disabled:cursor-not-allowed!`}
				placeholder={props.placeholder}
				onChange={props.onChange || handleChange}
				onKeyDown={props.onKeyPress}
				rows={props.rows || "3"}
				cols={props.cols || "30"}
				required={props.required || false}
				disabled={props.disabled || false}
				style={{
					backgroundColor: "var(--inputBackgroundColor)",
					color: "var(--textColor)",
					opacity: props.disabled ? "0.5" : "1",
					borderRadius: "var(--borderRadius)",
					boxSizing: "border-box",
					border: "1px solid var(--borderColor)",
				}}
			/>
			{error && (
				<span className="error-message">
					{error}
				</span>
			)}
		</label>
	);
};

export default TextAreaInput;
